
//REACT IMPORTS
import React, { useState, useEffect } from "react";

//MUI IMPORTS
import {
  Box,
  Container,
  Grid,
  Button,
  Typography,
  Paper,
  Card,
  CardContent,
  Divider,
  Stack,
  alpha,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoIcon from '@mui/icons-material/Info';

//CUSTOM IMPORTS
import ModalCargaPadron from "./ModalCargaPadron";
import {getData} from "../../../../../services/library"
import Navbar from "../../../../../components/Navbar";

const CargaPadronContribuyentes = () => {
  const [params, setParams]=useState();
  const [openCarga, setOpenCarga]=useState(false);
  const primaryColor = "#1F618D";

  useEffect(()=>{
    getData("/proveedores/params/all", setParams)
  },[])

  return (
    <div style={{ minHeight: "90vh", backgroundColor: "#FAFBFC" }}>
      <Navbar />
      <Box
        borderRadius={4}
        m={2}
        sx={{
          background: `linear-gradient(135deg, ${primaryColor} 0%, ${alpha(
            primaryColor,
            0.9
          )} 100%)`,
          color: "white",
          py: 3,
          mb: 2,
          boxShadow: "0 4px 20px rgba(31, 97, 141, 0.15)",
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={2}>
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "28px", md: "30px" },
                letterSpacing: "-0.5px",
              }}
            >
              Gestión de Archivo AFIP/ARCA
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                opacity: 0.95,
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              Carga de archivo de condición tributaria.
            </Typography>
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="xl" sx={{ pb: 2 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Card
              sx={{
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  background: `linear-gradient(to right, ${primaryColor}, ${alpha(
                    primaryColor,
                    0.85
                  )})`,
                  color: "white",
                  p: 2,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <span style={{ fontSize: "24px" }}>📋</span> Instrucciones
                </Typography>
              </Box>

              <CardContent sx={{ p: 2 }}>
                <Stack spacing={3}>
                  <Box>
                    <Stack direction="row" spacing={2} alignItems="flex-start">
                      <Box
                        sx={{
                          minWidth: 32,
                          height: 32,
                          borderRadius: "50%",
                          background: alpha(primaryColor, 0.1),
                          border: `2px solid ${primaryColor}`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 700,
                          color: primaryColor,
                          mt: 0.5,
                        }}
                      >
                        1
                      </Box>
                      <Box flex={1}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: primaryColor,
                            mb: 1,
                          }}
                        >
                          Descarga el archivo desde AFIP
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                          Ingresa a la página oficial de AFIP
                        </Typography>
                        <Button
                          variant="outlined"
                          size="small"
                          // href="https://www.afip.gob.ar/genericos/cInscripcion/archivoCompleto.asp"
                          href={params?.filter((param)=>param.id_param===1)[0]?.param}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            borderColor: primaryColor,
                            color: primaryColor,
                            fontWeight: 500,
                            textTransform: "none",
                            "&:hover": {
                              borderColor: primaryColor,
                              backgroundColor: alpha(primaryColor, 0.05),
                            },
                          }}
                        >
                          Ir a AFIP
                        </Button>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ display: "block", mt: 1 }}
                        >
                          Descarga: "Archivo condición tributaria con denominación / Apellido y Nombre"
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>

                  <Divider sx={{ my: 2, opacity: 0.5 }} />

                  <Box>
                    <Stack direction="row" spacing={2} alignItems="flex-start">
                      <Box
                        sx={{
                          minWidth: 32,
                          height: 32,
                          borderRadius: "50%",
                          background: alpha(primaryColor, 0.1),
                          border: `2px solid ${primaryColor}`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 700,
                          color: primaryColor,
                          mt: 0.5,
                        }}
                      >
                        2
                      </Box>
                      <Box flex={1}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: primaryColor,
                            mb: 2,
                          }}
                        >
                          Carga tu archivo en el servidor
                        </Typography>
                        <Button
                          variant="contained"
                          startIcon={<FileUploadIcon />}
                          onClick={() => setOpenCarga(true)}
                          sx={{
                            background: `linear-gradient(135deg, ${primaryColor}, ${alpha(
                              primaryColor,
                              0.85
                            )})`,
                            fontWeight: 600,
                            textTransform: "none",
                            py: 1.2,
                            px: 3,
                            borderRadius: "8px",
                            boxShadow: `0 4px 12px ${alpha(primaryColor, 0.3)}`,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              boxShadow: `0 6px 16px ${alpha(primaryColor, 0.4)}`,
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          Cargar archivo
                        </Button>
                      </Box>
                    </Stack>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={5}>
            <Stack spacing={3}>
              <Card
                sx={{
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                  borderRadius: "12px",
                  background: alpha(primaryColor, 0.02),
                  border: `1px solid ${alpha(primaryColor, 0.1)}`,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <CheckCircleOutlineIcon
                      sx={{
                        color: primaryColor,
                        fontSize: "28px",
                        mt: 0.5,
                      }}
                    />
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, color: primaryColor, mb: 0.5 }}
                      >
                        Archivo requerido
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Condición tributaria con denominación/apellido y nombre
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
              <Card
                sx={{
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                  borderRadius: "12px",
                  background: alpha(primaryColor, 0.02),
                  border: `1px solid ${alpha(primaryColor, 0.1)}`,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <AttachFileIcon
                      sx={{
                        color: primaryColor,
                        fontSize: "28px",
                        mt: 0.5,
                      }}
                    />
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, color: primaryColor, mb: 0.5 }}
                      >
                        Formatos soportados
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        ZIP
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>

              <Card
                sx={{
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                  borderRadius: "12px",
                  background: alpha(primaryColor, 0.02),
                  border: `1px solid ${alpha(primaryColor, 0.1)}`,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <InfoIcon
                      sx={{
                        color: primaryColor,
                        fontSize: "28px",
                        mt: 0.5,
                      }}
                    />
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, color: primaryColor, mb: 0.5 }}
                      >
                        Info
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Suba el archivo tal cual lo descargó (no hacen falta procesos de descompresión)
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
        </Grid>

        {openCarga && (
          <Box sx={{ mt: 4, animation: "fadeIn 0.3s ease" }}>
            <ModalCargaPadron open={openCarga} setOpen={setOpenCarga}/>
          </Box>
        )}
      </Container>
    </div>
  );
};

export default CargaPadronContribuyentes;
